
// https://brainder.org/2012/09/23/the-nifti-file-format/
export function isNiftiFile(file: Blob): Promise<boolean> {
	if (file.size < 348) {
		return Promise.resolve(false);
	}
	return new Promise<boolean>((resolve, reject) => {
		let headerBlob = file.slice(0, 348);

		let fileReader = new FileReader();

		fileReader.onload = evt => {
			let ba = <ArrayBuffer> evt.target.result;
			let u8 = new Uint8Array(ba);

			// header length value
			if (u8[0] !== 0x5c || u8[1] !== 0x01 || u8[2] !== 0 || u8[3] !== 0) {
				if (u8[3] !== 0x5c || u8[2] !== 0x01 || u8[1] !== 0 || u8[0] !== 0)
					return resolve(false);
			}
			
			// "n+1\0"
			if (u8[344] !== 0x6E || u8[345] !== 0x2B || u8[346] !== 0x31 || u8[347] !== 0)
				return resolve(false);

			return resolve(true);
		};

		fileReader.onerror = evt => {
			reject(fileReader.error);
		};
		fileReader.readAsArrayBuffer(headerBlob);
	});
}

export async function isGzipFile(file: Blob): Promise<boolean> {
	// Check if running in Node.js
	const isNode = typeof process !== 'undefined' && process.versions?.node;

	// Read first 10 bytes
	let headerBytes: Uint8Array;

	if (isNode) {
		// In Node.js
		const arrayBuffer = await file.arrayBuffer();
		headerBytes = new Uint8Array(arrayBuffer.slice(0, 10));
	} else {
		// In Browser
		headerBytes = await new Promise<Uint8Array>((resolve, reject) => {
			const headerBlob = file.slice(0, 10);
			const fileReader = new FileReader();
			fileReader.onload = evt => {
				const ba = evt.target?.result as ArrayBuffer;
				resolve(new Uint8Array(ba));
			};
			fileReader.onerror = () => reject(fileReader.error);
			fileReader.readAsArrayBuffer(headerBlob);
		});
	}

	// Check gzip magic numbers
	if (headerBytes[0] !== 0x1f || headerBytes[1] !== 0x8b) {
		return false;
	}
	if (headerBytes[2] !== 0x08) {
		return false;
	}

	return true;
}


export async function isNiftiOrGzipFile(file: Blob): Promise<boolean> {
	if (!await isNiftiFile(file))
		return await isGzipFile(file);
	return true;
}
